/**
 * @license
 *
 * Copyright IBM Corp. 2019, 2020
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */
/**
 * @license
 * 
 * This bundle contains the following third-party dependencies:
 * 
 * tslib:
 * 
 ****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
*****************************************************************************
 * 
 * flatpickr:
 * 
 *****************************************************************************
	    Copyright (c) Microsoft Corporation.

	    Permission to use, copy, modify, and/or distribute this software for any
	    purpose with or without fee is hereby granted.

	    THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
	    REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
	    AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
	    INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
	    LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
	    OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
	    PERFORMANCE OF THIS SOFTWARE.
	    *****************************************************************************
 * 
 * @carbon/motion:
 * 
 * Copyright IBM Corp. 2018, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 * @carbon/layout:
 * 
 * Copyright IBM Corp. 2018, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 * lit-html:
 * 
 * @license
 * Copyright 2022 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 * 
 * lit-element:
 * 
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 * 
 * @lit/reactive-element:
 * 
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 * 
 * Also refer to the following links for the license of other third-party dependencies:
 * 
 * https://www.npmjs.com/package/lit
 * https://www.npmjs.com/package/lodash-es
 * https://www.npmjs.com/package/@floating-ui/dom
 * https://www.npmjs.com/package/@floating-ui/utils
 * https://www.npmjs.com/package/@floating-ui/core
 */

import{s as t}from"./switcher-divider-499221b8.js";import{r as s,_ as e,p as o,x as i}from"./settings-9076e2f1.js";import{c as n}from"./carbon-element-017b212d.js";import{r as a}from"./state-4fe44a19.js";import"./property-742c16d1.js";import"./query-602de8af.js";import"./breakpoint-utility-ce297d00.js";import"./defs-6e0d1f36.js";import"./spread-b90dc9cf.js";import"./directive-e2d48b9c.js";import"./class-map-697ef015.js";import"./host-listener-da435cb9.js";import"./on-8707857f.js";import"./host-listener-cc8eee54.js";import"./collection-helpers-4af68304.js";import"./if-defined-fe856083.js";import"./focus-fa389ab8.js";import"./20-403ddc08.js";
/**
 * @license
 *
 * Copyright IBM Corp. 2021, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */let r=class extends s{connectedCallback(){this.hasAttribute("role")||this.setAttribute("role","separator"),super.connectedCallback()}};r.shadowRootOptions=Object.assign(Object.assign({},s.shadowRootOptions),{delegatesFocus:!0}),r.styles=t,r=e([n(`${o}-left-panel-divider`)],r);
/**
 * @license
 *
 * Copyright IBM Corp. 2021, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */
let c=class extends s{constructor(){super(...arguments),this._actionsCount=0,this._maxActions=3}connectedCallback(){this.hasAttribute("role")||this.setAttribute("role","list"),super.connectedCallback()}_handleActionsChange(t){var s;const e=t.target,o=null==e?void 0:e.assignedElements(),i=null!==(s=null==o?void 0:o.length)&&void 0!==s?s:0;i>this._maxActions?(this._actionsCount=this._maxActions,"development"===production&&console.error(`Too many left-panel-footer actions, max ${this._maxActions}.`)):this._actionsCount=i;for(let t=0;t<(null==o?void 0:o.length);t++)t+1>this._maxActions&&(o[t].setAttribute("hidden","true"),o[t].setAttribute(`data-actions-limit-${this._maxActions}-exceeded`,`${o.length}`))}render(){return i`
      <div
        class="${o}--left-panel-footer"
        ?hidden=${0===this._actionsCount}>
        <slot name="actions" @slotchange=${this._handleActionsChange}></slot>
      </div>
    `}};c.shadowRootOptions=Object.assign(Object.assign({},s.shadowRootOptions),{delegatesFocus:!0}),c.styles=t,e([a()],c.prototype,"_actionsCount",void 0),c=e([n(`${o}-left-panel-footer`)],c);
